// ** Bundle Support

let CartBundler = function () {
  this.init = function () {
    let Bundles = this.FindBundles();
    this.removeCache();
    this.BindBundles(Bundles);
  };

  this.BindBundles = function (bundles) {
    bundles.forEach((id) => {
      let $bundle_products = $('[bundle-id="' + id + '"]');
      console.log($bundle_products.length);

      let Total_price = 0;
      $bundle_products.each(function () {
        let price = $(this).attr("total-price");
        Total_price += parseInt(price);
      });

     let bundleFormattedPrice = (Total_price / 100).toLocaleString('en', {
        style: 'currency',
        currency: 'GBP'
      });

      let bundleSummary = `<div class="BundleSummary">
             <div class="BundleSummary--price"></div>
            <div class="BundleSummary--remove"></div>
           
            </div>`;
      let bundleTitle = `<div style="padding: 15px 15px 0px 15px;" class="BundleTitle">
                Pick & Mix
            </div><div class="BundleSummary" style="border-bottom-right-radius: 0; border-bottom-left-radius: 0; display: flex; width: 100%; margin-bottom: 0; padding-top: 0;">
             <div class="BundleSummary--price" style="text-align:left;">${bundleFormattedPrice}</div>
            <div class="BundleSummary--remove" style="margin-top: -25px;"><a href="#" class="cart__remove-bundle" data-bundle-id="${id}">
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
              <g id="icomoon-ignore"></g><path d="M64 160v320c0 17.6 14.4 32 32 32h288c17.6 0 32-14.4 32-32v-320h-352zM160 448h-32v-224h32v224zM224 448h-32v-224h32v224zM288 448h-32v-224h32v224zM352 448h-32v-224h32v224z"></path>
              <path d="M424 64h-104v-40c0-13.2-10.8-24-24-24h-112c-13.2 0-24 10.8-24 24v40h-104c-13.2 0-24 10.8-24 24v40h416v-40c0-13.2-10.8-24-24-24zM288 64h-96v-31.599h96v31.599z"></path>
              </svg>
            </a></div>
           
            </div>`;

      $($bundle_products[$bundle_products.length - 1]).after(bundleSummary);
      $($bundle_products[0]).before(bundleTitle);
      // Registers each cart bundle item's remove button
    });
  };

  this.removeCache = function () {
    $(".BundleSummary").remove();
    $(".BundleTitle").remove();
  };

  this.FindBundles = function () {
    let Bundles = [];
    let $cache = {
        bundles: $("[bundle-id]"),
      },
      last_bundle_id;

    $cache.bundles.each(function () {
      let self = $(this),
        BundleID = $(self).attr("bundle-id");

      if (last_bundle_id != BundleID) Bundles.push(BundleID);
      last_bundle_id = BundleID;
    });

    return Bundles;
  };
};

window.CartBundler = new CartBundler();

const shippingProgressCalculator = (count) => {
  let btnText =
    count === 0
      ? "Continue Shopping"
      : `<span id="cart-btn-icon"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-lock" viewBox="0 0 28.3 28.3"><path fill="#FFF" d="M22.9,12.3H21V8.5c0-3.7-2.9-6.6-6.6-6.6c-3.7,0-6.6,2.9-6.6,6.6v3.8H5.9V8.5C5.9,3.8,9.7,0,14.4,0
	c4.7,0,8.5,3.8,8.5,8.5V12.3z"></path><path fill="#FFF" d="M21.9,28.3H6.8c-1.6,0-2.8-1.2-2.8-2.8V14.2c0-1.6,1.2-2.8,2.8-2.8h15.1c1.6,0,2.8,1.2,2.8,2.8v11.3
	C24.8,27.1,23.5,28.3,21.9,28.3 M6.8,13.2c-0.6,0-0.9,0.4-0.9,0.9v11.3c0,0.6,0.4,0.9,0.9,0.9h15.1c0.6,0,0.9-0.4,0.9-0.9V14.2
	c0-0.6-0.4-0.9-0.9-0.9H6.8z"></path><path fill="#FFF" d="M14.4,15.1c1,0,1.9,0.8,1.9,1.9c0,1-0.8,1.9-1.9,1.9s-1.9-0.8-1.9-1.9C12.5,16,13.3,15.1,14.4,15.1"></path>
<polygon fill="#FFF" points="14.9,17 13.9,17 13,22.7 15.8,22.7 "></polygon></svg></span> Checkout`;
  let btnHref = count === 0 ? "/collections/shop" : "/checkout";
  const $shipping__calculator = $(".free-shipping__calculator");
  const $progress_bar = $shipping__calculator.prev().find(".progress");
  let message =
    count === 0
      ? "Add 4 more cases and get free shipping"
      : count === 1
      ? "Add 3 more cases and get free shipping"
      : count === 2
      ? "Add 2 more cases and get free shipping"
      : count === 3
      ? "Add 1 more case and get free shipping"
      : "Free shipping unlocked";
  $(".free-shipping__calculator").html(message);

  const progBar = $(".progress");

  if (count === 0) {
    progBar.css("width", "0");
  } else if (count === 1) {
    progBar.css("width", "25%");
  } else if (count === 2) {
    progBar.css("width", "50%");
  } else if (count === 3) {
    progBar.css("width", "75%");
  } else if (count >= 4) {
    progBar.css("width", "100%");
  }

  $progress_bar.attr("data-progress", count);

  //checkout button
  $(".cart__checkout").html(btnText);
  $(".cart__checkout[href]").attr("href", btnHref);

  // discount wrapper & subtotal and savings wrapper
  if (count === 0) {
    $(".discount-wrap").hide();
    $("#sub-save-wrapper").hide();
    $("#cart-btn-icon").hide();
  } else {
    $(".discount-wrap").show();
    $("#sub-save-wrapper").show();
    $("#cart-btn-icon").show();
  }

  $("#AddToCart-product-template").click(function () {
    $(".discount-wrap").show();
  });
};

function hideNoQty(count) {
  let noQtyHide = document.querySelectorAll(".no-qty-hide");
  console.log("coujnt", count);
  noQtyHide.forEach((element) => {
    if (count > 0) return (element.style.display = "");
    else return (element.style.display = "none");
  });
}

$(function () {
  window.CartBundler.init();

  // discount application script
  let applyBtn = document.querySelector("#apply-discount-btn");
  let discountWrap = document.querySelector(".discount-wrap");
  let removeCodeBtn = document.querySelector("#remove-discountCode-btn");
  let savingsContent = document.querySelector("#savings-wrap");
  let cart__total_price = document.querySelector("#cart__total_price");
  let cart__savings_price = document.querySelector("#cart__discounted_amount");
  let discountCodeStatus = document.querySelector("#discount-code-status");
  let checkoutContainer = document.createElement("div");
  let discountCode = document.querySelector(
    ".discount-code .discount-code-value"
  );
  let discountCodeInput = document.querySelector("#discount-code");
  let totalCart = document.querySelector(
    ".cart-sidebar-item span:last-child strong"
  ); // Total Cart Selector to update the total ammount.
  checkoutContainer.id = "checkout-container";
  document.body.appendChild(checkoutContainer);

  // discount code add background color if there's value
  discountCodeInput.addEventListener("input", function () {
    if (discountCodeInput.value !== "") {
      discountCodeInput.style.backgroundColor = "#ebf5ff";
    } else {
      discountCodeInput.style.backgroundColor = "";
    }
  });

  applyBtn.addEventListener("click", function (e) {
    applyDiscount(discountCodeInput.value, "m");
  });

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  }

  function applyDiscount(code, action, openmodal) {
    applyBtn.innerHTML += "<div class='loader'></div>";
    applyBtn.style.pointerEvents = "none";
    let discountApplyUrl =
      "https://dash-water-uk.myshopify.com/checkout?discount=" + code + "&t=" + Date.now();
    fetch(discountApplyUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (data) {
        let discountError = data.match('id="error-for-reduction_code"');
        checkoutContainer.innerHTML = data;
        let summary = checkoutContainer.querySelector(".sidebar");
        let total = checkoutContainer
          .querySelector(".payment-due__price")
          .textContent.trim();
        if (discountError) {
          let discountErrorMsg = summary
            .querySelector(".field__message.field__message--error")
            .textContent.replace(" or gift card", ".");
          console.log(discountErrorMsg);
          discountCodeStatus.innerHTML =
            "<small class='discount-error-msg'>" +
            discountErrorMsg +
            "</small>";
          discountCodeInput.style.border = "1px solid red";
        } else {
          discountCodeInput.style.border = "";
          discountCode.innerHTML = code.trim();
          localStorage.setItem("discountCode", code.trim());
          discountCodeStatus.innerHTML = "";
        }
        applyBtn.style.pointerEvents = "auto";

        const priceWithDiscount = total.replace("£", "");
        const priceWithoutDiscount = cart__total_price.innerHTML.replace(
          "£",
          ""
        );
        // discount vaue
        const totalDiscount = Math.abs(
          priceWithoutDiscount - priceWithDiscount
        );

        // update cart total price
        cart__total_price.innerHTML = "£" + priceWithDiscount;

        // TODO:
        // - Add discount calculation

        // cart__savings_price.innerHTML = savingPrice;
        const cartSavings = document.getElementById("cart__savings_price");
        const savingsSpan = document.querySelector('.cart__savings_price-wrap span');
        if (totalDiscount === 0) {
          cartSavings.textContent = "Code Invalid";
          savingsSpan.style.display = 'none';
        } else {
          cartSavings.textContent = totalDiscount.toLocaleString("en-GB", {
            style: "currency",
            currency: "GBP",
          });
        }

        // - add remove discount
        removeCodeBtn.addEventListener("click", function () {
          discountCodeInput.value = "";
          localStorage.removeItem("discountCode");
          removeCodeBtn.classList.remove("active");
          applyBtn.classList.add("active");
          discountCodeInput.classList.remove("active");
          savingsContent.classList.remove("active");
          cart__total_price.innerHTML = "£" + priceWithoutDiscount;
        });

        function updateDivClass() {
          if (localStorage.getItem("discountCode")) {
            removeCodeBtn.classList.add("active");
            savingsContent.classList.add("active");
            discountCodeInput.classList.add("active");
            applyBtn.classList.remove("active");
          } else {
            removeCodeBtn.classList.remove("active");
            discountCodeInput.classList.remove("active");
          }
        }
        updateDivClass();
        // add discount code inside the input
        const myInputCode = document.getElementById("discount-code");
        myInputCode.value = discountCode.innerHTML;

        console.log(priceWithDiscount, priceWithoutDiscount, totalDiscount);
        checkoutContainer.innerHTML = "";
        applyBtn.innerHTML = "APPLY";

        if (openmodal) openModal();
      });
    }

  const hasDiscount = getCookie("discount_code");
  if (hasDiscount) {
    applyDiscount(hasDiscount, "a");
  } else {
    localStorage.removeItem("discountCode");
  }

  if (
    document.querySelector('[item-handle="bestseller-96"]') ||
    document.querySelector('[item-handle="bestsellers-48"]')
  ) {
    shippingProgressCalculator(4);
  }

  $(document).on("cart.requestStarted", function (event, cart) {
    window.CartBundler.init();
    hideNoQty(cart.item_count);
  });

  $(this).on("cart.requestComplete", function (event, cart) {
    let discountWrap = document.querySelector(".discount-wrap");
    hideNoQty(cart.item_count);
    // update cart count in header
    $(".cart-count").html((cart.item_count > 9 ? "" : "0") + cart.item_count);
    $(".ajaxcart-heading").html(`MY CART (${cart.item_count})`);

    // toggle discount fields
    if (cart.item_count > 0)
      discountWrap.classList.remove("discount-cart-hidden");
    else discountWrap.classList.add("discount-cart-hidden");

    // reinitiate bundle layout builder
    window.CartBundler.init();

    // calculate free shipping
    if (
      document.querySelector('[item-handle="bestseller-96"]') ||
      document.querySelector('[item-handle="bestsellers-48"]')
    ) {
      shippingProgressCalculator(4);
    } else {
      shippingProgressCalculator(cart.item_count);
      
    cart.items.forEach(function(item) {
      if (typeof item.selling_plan_allocation === 'object') {
        shippingProgressCalculator(4);
      }
    })

    }
    // check for current discount
    if (localStorage.discountCode) {
      CartJS.render(event, cart); // force render!
      applyDiscount(
        localStorage.discountCode ? localStorage.discountCode : hasDiscount,
        "a",
        false
      );
    } 
    //   else {
    //   openModal();
    // }
  });
});


$(".single-prod-btn").click(function () {
  openModal();
});

$(document).on('cart.ready', function(event, cart) {
  cart.items.forEach(function(item) {
    if (typeof item.selling_plan_allocation === 'object') {
      shippingProgressCalculator(4);
    }
  })
});

// $(document).ready(function() {
//   // Cart Total
//   let totalPrice = $('#cart__total_price').text();
//   let formattedPrice = totalPrice;
//   let formattedNumber = '£' + (totalPrice / 100).toFixed(2);

//   $('#cart__total_price').text(formattedNumber);

// });

// $(document).ready(function() {
//   // Format all div elements with ID ajaxcart__price-wdiscount
//   $('.ajaxcart__price-wdiscount').each(function() {
//     var price = $(this).text();
//     var formattedPrice = '£' + (parseFloat(price) / 100).toFixed(2);
//     $(this).text(formattedPrice);
//   });

//   // Console log the formatted values
//   $('.ajaxcart__price-wdiscount').each(function() {
//     console.log($(this).text());
//   });
// })

$(document).ready(function() {
  rivets.formatters.currency = function(value) {
      return '$' + (value / 100).toFixed(2);
  }
})
